<template>
  <div>
    <ul v-if="items.length > 0">
      <li v-for="(item, index) in items" class="offset">
        <i class="fa fa-caret-right fa-fw"></i>
        <strong>{{ item.dayString }}</strong>
        <span>from</span>
        <strong>{{ item.timeFromString }}</strong>
        <span>to</span>
        <strong>{{ item.timeToString }}</strong>
        <span>:</span>
        <strong>{{ item.offset }} mins</strong>
        <span class="btn-actions">
          <a href="javascript:;" class="button cta xsmall" @click="edit(index)">EDIT</a>
          <a href="javascript:;" class="button cta xsmall error" @click="remove(index)">DELETE</a>
        </span>
      </li>
    </ul>
    <div class="add-container">
      <a href="javascript:;" class="button cta xsmall success" @click="edit(-1)">ADD NEW ITEM</a>
    </div>
    <div v-bind:class="{ 'field-modal': true, show: showFieldModal }" @click="showFieldModal = false">
      <div class="field-container">
        <div class="field-content">
          <div class="fields" @click.stop>
            <div class="field-title">SET PICKUP TIME OFFSET</div>
            <div class="row">
              <div class="small-12 columns">
                <div class="select-input">
                  <label>DAY OF WEEK</label>
                  <select v-model.number="fieldItem.dayOfWeek">
                    <option value="0">Sunday</option>
                    <option value="1">Monday</option>
                    <option value="2">Tuesday</option>
                    <option value="3">Wednesday</option>
                    <option value="4">Thursday</option>
                    <option value="5">Friday</option>
                    <option value="6">Saturday</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row margin-T">
              <div class="small-6 columns padding-R">
                <div class="time-input select-input">
                  <label>TIME FROM</label>
                  <div class="row">
                    <div class="small-6 columns padding-R">
                      <select v-model="fieldItem.timeFromHH">
                        <option v-for="i in 24" :value="(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)">
                          {{ (i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1) }}
                        </option>
                      </select>
                    </div>
                    <div class="small-6 columns padding-L">
                      <select v-model="fieldItem.timeFromMM">
                        <option v-for="i in 60" :value="(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)">
                          {{ (i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1) }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="small-6 columns padding-L">
                <div class="time-input select-input">
                  <label>TIME TO</label>
                  <div class="row">
                    <div class="small-6 columns padding-R">
                      <select v-model="fieldItem.timeToHH">
                        <option v-for="i in 24" :value="(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)">
                          {{ (i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1) }}
                        </option>
                      </select>
                    </div>
                    <div class="small-6 columns padding-L">
                      <select v-model="fieldItem.timeToMM">
                        <option v-for="i in 60" :value="(i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1)">
                          {{ (i - 1) < 10 ? ('0' + (i - 1)) : ('' + i - 1) }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row margin-T">
              <div class="small-12 columns">
                <div class="number-input">
                  <label>OFFSET (IN MINUTES)</label>
                  <input type="number" v-model.number="fieldItem.offset" />
                </div>
              </div>
            </div>
            <a class="button cta xsmall block success" href="javascript:;" @click="save">SAVE PICKUP TIME OFFSET</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'pickuptime-offsets',
  props: [ 'settingKey' ],
  data () {
    return {
      items: [],
      showFieldModal: false,
      fieldItem: {
        dayOfWeek: 0,
        timeFromHH: '00',
        timeFromMM: '00',
        timeToHH: '00',
        timeToMM: '00',
        offset: 0
      },
      indexToEdit: -1
    }
  },
  computed: {
    stringValue () {
      let configuration = this.$store.state.settingsPage.configuration
      if (this.settingKey in configuration) {
        return configuration[this.settingKey].value
      }
      return ''
    }
  },
  methods: {
    edit (index) {
      let self = this
      if (index < 0) {
        self.fieldItem = {
          dayOfWeek: 0,
          timeFromHH: '00',
          timeFromMM: '00',
          timeToHH: '00',
          timeToMM: '00',
          offset: 0
        }
      } else {
        let item = self.items[index]
        let timeFrom = moment(item.timeFrom, 'HHmm')
        let timeTo = moment(item.timeTo, 'HHmm')
        self.fieldItem = {
          dayOfWeek: item.dayOfWeek,
          timeFromHH: timeFrom.format('HH'),
          timeFromMM: timeFrom.format('mm'),
          timeToHH: timeTo.format('HH'),
          timeToMM: timeTo.format('mm'),
          offset: parseInt(item.offset)
        }
      }
      self.indexToEdit = index
      self.showFieldModal = true
    },
    remove (index) {
      let self = this
      if (index >= 0) {
        self.items.splice(index, 1);
      }
      self.writeToStore()
    },
    save () {
      let self = this

      let item = '' + self.fieldItem.dayOfWeek
      item += self.fieldItem.timeFromHH
      item += self.fieldItem.timeFromMM
      item += self.fieldItem.timeToHH
      item += self.fieldItem.timeToMM
      item += self.fieldItem.offset
      let configItem = {
        dayOfWeek: parseInt(item.charAt(0)),
        timeFrom: item.substring(1, 5),
        timeTo: item.substring(5, 9),
        offset: item.substring(9),
        dayString: moment(parseInt(item.charAt(0)), 'd').format('ddd'),
        timeFromString: moment(item.substring(1, 5), 'HHmm').format('hh:mmA'),
        timeToString: moment(item.substring(5, 9), 'HHmm').format('hh:mmA')
      }
      if (self.indexToEdit >= 0) {
        self.items[self.indexToEdit] = configItem
      } else {
        self.items.push(configItem)
      }

      self.writeToStore()
      self.showFieldModal = false
    },
    writeToStore () {
      let self = this
      let result = ''
      for (let i = 0; i < self.items.length; i++) {
        let item = self.items[i]
        result += item.dayOfWeek
        result += item.timeFrom
        result += item.timeTo
        result += item.offset
        if (i < self.items.length - 1) {
          result += ','
        }
      }

      let configItem = {
        key: self.settingKey,
        value: result
      }
      self.$store.commit('settingsPage/setConfigurationItem', configItem)
    }
  },
  watch: {
    stringValue (value) {
      let self = this
      if (value === '') {
        self.items = []
        return
      }

      self.items = []
      let stringItems = value.split(',')
      for (let i = 0; i < stringItems.length; i++) {
        let item = stringItems[i].trim()
        if (item === '') {
          continue
        }

        self.items.push({
          dayOfWeek: parseInt(item.charAt(0)),
          timeFrom: item.substring(1, 5),
          timeTo: item.substring(5, 9),
          offset: item.substring(9),
          dayString: moment(parseInt(item.charAt(0)), 'd').format('ddd'),
          timeFromString: moment(item.substring(1, 5), 'HHmm').format('hh:mmA'),
          timeToString: moment(item.substring(5, 9), 'HHmm').format('hh:mmA')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  display: block;
  margin: 0;
  padding: 0;
  list-style-type: none;
  font-size: 14px;

  & .offset {
    display: block;
    position: relative;
    padding: 5px 0 15px;

    & > * {
      display: inline-block;
      vertical-align: middle;
    }

    & strong { text-decoration: underline; }

    & > a.button {
      position: absolute;
      top: 0;
      right: 72px;

      &.error {
        right: 0;
      }
    }
  }
}

.add-container {
  text-align: center;
  border-top: 1px solid rgba(0,0,0,0.15);
  padding-top: 10px;
}

.field-modal {
  position: fixed;
  z-index: 13;
  background-color: rgba(0,0,0,0.5);
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  opacity: 0;
  transition: all 250ms;

  &.show {
    top: 0;
    opacity: 1;
  }
}
.field-container {
  display: table;
  position: absolute;
  z-index: 14;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & .field-content {
    display: table-cell;
    vertical-align: middle;
  }

  & .fields {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.3);
    max-width: 500px;
    margin: 0 auto;
    padding: 15px;
  }

  & .field-title {
    text-align: center;
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
    margin-bottom: 10px;
    margin-top: 5px;
  }

  & .cta {
    margin-top: 20px;
  }
}

.select-input {
  & label {
    font-size: 11px;
    font-weight: 700;
  }

  & select {
    font-size: 14px;
    height: 37px;
    outline: 0;
    padding: 7px 10px;
    display: block;
    border-color: rgba(0,0,0,0.15);
    background-color: #fff;
    border-radius: 3px;
  }
}

.number-input {
  & label {
    font-size: 11px;
    font-weight: 700;
  }
  & input {
    margin-top: 0;
    font-size: 14px;
    padding: 7px 10px;
  }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
.margin-T { margin-top: 15px; }

@media only screen and (max-width: 430px) {
  .field-container .fields {
    margin: 0 10px;
  }
  ul .offset {
    .btn-actions {
      margin-top: 6px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/controls/PickupTimeOffsets.vue